// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"33":"17a372ec","138":"fcf2cdda","777":"f8efe27f","970":"fcff2385"}[chunkId] + ".chunk.js";
};